import { render, staticRenderFns } from "./mainAccountManagement.vue?vue&type=template&id=4e0ff06d&scoped=true&"
import script from "./mainAccountManagement.vue?vue&type=script&lang=js&"
export * from "./mainAccountManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ff06d",
  null
  
)

export default component.exports